import { createReducer, on } from '@ngrx/store';

import * as LicenseActions from './license.actions';
import { licenseStateAdapter, initialLicenseState } from './license.state';

export const reducer = createReducer(
  initialLicenseState,
  on(LicenseActions.licensesLoadedSuccess, (state, action) =>
    licenseStateAdapter.setAll(action.licenses, state)
  ),
  on(LicenseActions.licensesLoadedFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(LicenseActions.loadLicenses, () => initialLicenseState),
  on(LicenseActions.clearLicenses, (state) =>
    licenseStateAdapter.removeAll(state)
  )
);
